import { erpApi } from '@/shared/axios/erp-api';
import { getUrlParamsFetch, handleAxiosError, urlBackend } from "@/shared";
import { IDataSolicitudSupercionParams, } from "@/shared/interfaces/erp/supervision/supervision.interface";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AlertSeverityEnum, UseMutationsParams } from '@/shared/interfaces';
import { ISolicitudDesbloqueoCoorporativoResp, ISolicitudDesbloqueoCoorporativoParams, ISolicitudDesbloqueoCorporativo } from '@/shared/interfaces/erp/supervision/solicitud_nueva_linea_corporativo';

const { get, post, put } = erpApi();


///* Obtener todas los solicitudes corporativos

export const useGetSolicitudLineaCorp = (params?: IDataSolicitudSupercionParams) => {
  return useQuery({
    queryKey: ['solicituddesbloqueocoorporativo', ...Object.values(params || {})],
    queryFn: async () => {
      return getSolicitudLineaCorp(params);
    },
    refetchOnWindowFocus: false
  });
}

export const getSolicitudLineaCorp = async (params?: IDataSolicitudSupercionParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<ISolicitudDesbloqueoCoorporativoResp>(`${urlBackend}api/v1/solicituddesbloqueocoorporativo/?${queryParams}`, true);
  return resp;
}

///* Crear solicitud

export const usePostSolicitudLineaCorp = ({
  navigate,
  enableRedirect = true,
  returnUrl,
  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams = {}) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: (params: ISolicitudDesbloqueoCoorporativoParams) =>
      postSolicitudLineaCorp(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['solicituddesbloqueocoorporativo'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Solicitud creada correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert)
    },
    onSettled: () => {
      //setIsGlobalLoading(false);
    },
  });
};

export const postSolicitudLineaCorp = async (
  data: ISolicitudDesbloqueoCoorporativoParams
) => {

  return post<ISolicitudDesbloqueoCorporativo>(
    `${urlBackend}api/v1/solicituddesbloqueocoorporativo/`,
    data,
    true
  );
};


///* Actualizar solicitu de libreacion corporativo

interface IPutSolicitudCorp {
  id: string,
  data: ISolicitudDesbloqueoCoorporativoParams
}
export const usePutSolicitudLineaCorp = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,

  customSuccessCallback,
}: UseMutationsParams = {}) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: (params: IPutSolicitudCorp) =>
      putSolicitudLineaCorp(params),

    onSuccess: res => {
      queryClient.invalidateQueries({ queryKey: ['solicituddesbloqueocoorporativo'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Solicitud actualizada correctamente',
          AlertSeverityEnum.success
        );

      customSuccessCallback && customSuccessCallback(res?.data);
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const putSolicitudLineaCorp = async ({
  id,
  data,
}: IPutSolicitudCorp) => {

  return put<ISolicitudDesbloqueoCoorporativoResp>(
    `${urlBackend}api/v1/solicituddesbloqueocoorporativo/${id}/`,
    data,
    true
  );
};